import React from 'react';
import Radio from '@material-ui/core/Radio';

export default function QCXRadio(props) {
  return (
    <Radio {...props} />
  );
}
